// Copyright (c) Move Closer 2022.

import { AnyObject, IConnector, IResponse, Repository, ResourceActionFailed } from '@movecloser/front-core'

import { IRelatedService, ProductData, RelatedSuggestedProducts } from '../../../contexts'

import { IProductsRepository } from '../contracts/repositories'
import { resolveFromStatus } from '../../../support'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export class ProductsRepository extends Repository<ProductData> implements IProductsRepository {
  protected useAdapter = true

  protected relatedService: IRelatedService

  constructor (connector: IConnector, relatedService: IRelatedService) {
    super(() => connector)
    this.relatedService = relatedService
  }

  /**
   * TODO.
   */
  public addReview (productSku: string, payload: AnyObject): Promise<void> {
    return Promise.resolve()
  }

  /**
   * @inheritDoc
   */
  public async loadProductsBySkus (
    skus?: string[] | null,
    action?: string | null,
    campaign?: string | null,
    amountToFreeDelivery?: number,
    syneriseCookie?: string
  ): Promise<ProductData[]> {
    const response: IResponse = await this.connector.call('products', 'loadProducts', {}, {
      sku: skus ? skus.join(',') : null,
      action: action ?? null,
      campaign: campaign ?? null,
      min_price: amountToFreeDelivery,
      _snrs_uuid: syneriseCookie
    })

    if (!response.isSuccessful()) {
      throw new ResourceActionFailed(
        response.errors?.message,
        resolveFromStatus(response),
        {}
      )
    }

    try {
      this.relatedService.storeRelated(response.data.meta)

      return await this.relatedService.resolve(response.data.data.collection)
    } catch (e) {
      throw new Error((e as Error).message)
    }
  }
}
